import InputComponent from "./components/InputComponent";
import { InputContextProvider } from "./context/input-context";

function Page() {
  return (
    <InputContextProvider>
      <InputComponent />
    </InputContextProvider>
  )
}

export default Page;
